import { useState } from "react";
import { Link } from "react-router";
import { Button, Icon } from "@xinghai/ui";
import { copyCurrentUrl } from "../../lib/ua";

/**
 * Full-screen notice shown on the record page inside the WeChat browser
 * (docs/ROADMAP.md B1). Only the record page is blocked — the student can
 * still browse their tasks and recordings here.
 */
export function WeChatNotice() {
  const [copied, setCopied] = useState<"idle" | "done" | "failed">("idle");
  return (
    <div className="xz-container xz-wechat" role="alert">
      <Icon id="ui-warning" size={24} />
      <h1 className="gz-type-heading">请用手机自带的浏览器打开</h1>
      <p className="gz-type-reading">
        微信里的浏览器录不了音。请点右上角的「…」选「在浏览器中打开」， 或者复制下面的链接，粘贴到
        Safari（苹果）或 Chrome（安卓）里再录。
      </p>
      <p className="xz-wechat__url gz-type-code">{window.location.href}</p>
      <Button
        variant="primary"
        size="lg"
        block
        onClick={() => {
          void copyCurrentUrl().then((ok) => setCopied(ok ? "done" : "failed"));
        }}
      >
        <Icon id="ui-save" size={20} /> 复制链接
      </Button>
      {copied === "done" && (
        <p className="gz-notice" role="status">
          <Icon id="ui-check-circle" size={20} />
          链接已复制，去浏览器里粘贴打开。
        </p>
      )}
      {copied === "failed" && (
        <p className="gz-notice gz-notice--error" role="status">
          <Icon id="ui-info" size={20} />
          这里复制不了，请长按上面的链接手动复制。
        </p>
      )}
      <Link className="gz-button" to="/s">
        先回任务列表
      </Link>
    </div>
  );
}
